import classNames from 'classnames';

import CalendarCross from 'components/common/icons';

import * as mixpanel from 'services/mixPanel';

import { leaveStatus } from 'constants/leave';
import { mixPanelEvents } from 'constants/mixPanel';
import { LEAVE_DETAIL_URL } from 'constants/endpoints';
import { LEAVE_STATUS_COLORS } from 'constants/leavePlan';
import { ABBREVIATED_DATE_FORMAT } from 'constants/appConstants';

import { interpolate } from 'utils/string';
import { getFormattedDate, sortByAscendingDate } from 'utils/date';

import type { PlannedLeave } from '../types';

const PlannedLeavesInfo = ({ plannedLeaves }: { plannedLeaves: PlannedLeave[] }) => {
  const sortedDate = sortByAscendingDate(plannedLeaves, 'leaveStartDate') as PlannedLeave[];

  return (
    <div className="planned-leaves-info">
      {sortedDate?.map((date, index) => {
        let formattedDate = '';

        if (date.leaveStartDate === date.leaveEndDate) {
          formattedDate = getFormattedDate(date.leaveStartDate, ABBREVIATED_DATE_FORMAT);
        } else {
          formattedDate =
            getFormattedDate(date.leaveStartDate, ABBREVIATED_DATE_FORMAT) +
            ' - ' +
            getFormattedDate(date.leaveEndDate, ABBREVIATED_DATE_FORMAT);
        }

        const isLeavePending = date.leaveStatus === leaveStatus.REQUESTED.toUpperCase();

        const calendarCrossColor = isLeavePending ? LEAVE_STATUS_COLORS.REQUESTED : LEAVE_STATUS_COLORS.DEFAULT;

        const mixPanelEvent = isLeavePending
          ? mixPanelEvents.select.requestedPlannedLeaves
          : mixPanelEvents.select.approvedPlannedLeaves;

        return (
          <div key={`${String(date?.leaveDate || index)}`} className="planned-leaves-info__items">
            <a
              href={interpolate(LEAVE_DETAIL_URL, { id: String(date.leaveId || '') })}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => mixpanel.trackEvent(mixPanelEvent)}
            >
              <div
                className={classNames('attendance__planned-leaves d-flex align-items-center', {
                  'attendance__pending-color-theme': isLeavePending,
                  'attendance__approved-color-theme': !isLeavePending,
                })}
              >
                <span data-cy="attendance-leave-status" className="attendance__leave-status d-flex pr-4">
                  <CalendarCross size={16} color={calendarCrossColor} />
                </span>
                <p className="attendance__data-count">{formattedDate}</p>
              </div>
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default PlannedLeavesInfo;
